import React from 'react';

import Form from '../../../gd-form/form/form-modal-new/form-modal-new';
import FormManager from '../../../gd-form/common/form-manager';
import FormError from '../../../gd-form/common/form-error/form-error';
import Input from '../../../../core/gd-form/form-element/input/input.jsx';
import ProjectColor from '../../../gd-form/form-element/project-color/project-color';
import ModalV4HeaderWhite from "../../../../app/ui/modal/v4/header-white/v4-header-white";
import SelectParentNew from "../../../gd-ui/select-parent-new/select-parent-new";
import {EntityType} from "../../../gd/const/item";
import {SelectParent_RenderType} from "../../../gd-ui/select-parent-new/@const";
import ApiProject from "../../../gd/api/project";

type Props = {
    params          : any

    onTagSelect     : callback
    onClick         : callback
    onCloseClick    : callback
    onClickBack     : callback
}

type State = {
    companyId               : ID
    parentProjectId         : ID | null
    colorSelectedManually   : boolean
}

export default class AddTagNew extends React.Component<Props, State> {

    public form!: FormManager

    constructor(props: Props) {
        super(props);
        const { params } = props;

        this.state = {
            companyId               : params && params.companyId ? params.companyId : gd.companyId,
            parentProjectId         : null,
            colorSelectedManually   : false
        };
    }

    UNSAFE_componentWillMount() {
        const initFormData = {
            company: this.state.companyId,
            parentProject: this.state.parentProjectId,
            name: '',
            color: 7
        };

        const formStructure = {
            fields: {
                color: {
                    type: 'select',
                    isRequired: true,
                    label: 'Color',
                    onUserChange: (()=>{
                        this.setState({colorSelectedManually: true})
                    })
                },

                company: {
                    type: 'select',
                    isRequired: true,
                    label: 'Workfolder parent',
                },

                parentProject: {
                    type: 'select',
                    isRequired: false,
                    onUserChange: this.onParentChange
                },

                name: {
                    type: 'input',
                    isRequired: true
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onParentChange = () => {
        this.setState({
            companyId: this.form.getValue('company'),
            parentProjectId: this.form.getValue('parentProject')
        })
    };

    onSubmit = async (result: any) => {

        try {
            const response = await ApiProject.newTag(result).promise()
            this.form.reset();
            this.form.setFieldValue('name','');
            this.props.onTagSelect(response.projectId);
        } catch (e){
            console.error(e)
        }

    };

    onParentSelected = (projectId: ID) => {
        this.form.setFieldValue("company", gd.companyId);
        this.form.setFieldValue("parentProject", projectId);

        if (!this.state.colorSelectedManually && projectId) {
            const parentColor = gd.session.projects.get(projectId)?.color;

            this.form.setFieldValue("color", parentColor);
            this.form.fields.color.component.forceUpdate(); //why not just go with setstate for form ? :)
        }

        this.onParentChange();
    };

    render() {
        const { companyId, parentProjectId } = this.state;

        const parentValue = parentProjectId

        const companyRow = (
            <div className="row">
                <div className="label">Parent</div>
                <div className="element">

                    <SelectParentNew projectId                  = {parentValue}
                                     parentsFor                 = {EntityType.TASK_TAG}
                                     renderType                 = {SelectParent_RenderType.FORM}
                                     canBeNull                  = {true}
                                     onChange                   = {this.onParentSelected}/>

                    <FormError form={this.form} name="company" />
                    <FormError form={this.form} name="parentProject" />
                </div>
            </div>
        );

        return (

            <div className="v4-container placement-middle create-tag" onClick={this.props.onClick}>

                <ModalV4HeaderWhite height={60} title="Create a Tag" onClose={this.props.onCloseClick} onGoBack={this.props.onClickBack} />

                <div className="main">

                    <Form className="new-tag-form" form={this.form} submitBtnClass="grey">

                        <div className="tbl">

                            {companyRow}

                            <div className="row">
                                <div className="label">Name</div>
                                <div className="element tag-name-container">
                                    <Input size="big" form={this.form} name="name" className="with-color" />
                                    <ProjectColor name="color" form={this.form} />

                                    <FormError form={this.form} name="name" />
                                    <FormError form={this.form} name="color" />
                                </div>
                            </div>

                        </div>
                    </Form>

                </div>

            </div>
        )
    }
}
